export const getCustomerId = (partnerName: string, id: string | null) =>
  (partnerName === 'hub' && id) || undefined
